import { Aside } from '@atlaskit/navigation-system/layout/aside';
import { PanelSplitter } from '@atlaskit/navigation-system/layout/panel-splitter';

// we currently don't have anything in Aside. Keeping here until we finish porting everything
// over but if nothing goes in this section we can remove it (and the corresponding layout visibility code)
export function NavSystemAside() {
  return (
    <Aside>
      <PanelSplitter label="" />
    </Aside>
  );
}
